import color from 'string-to-color';

export const stringToColour = (str: string): string => {
  return color(str);
};
